import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FoljaBaza } from '@core/interfaces/models/folja-baza.interface';
import { FoljaDeftoreService } from './folja-deftore.service';
import { FoljaDeshiroreService } from './folja-deshirore.service';
import { FoljaHabitoreService } from './folja-habitore.service';
import { FoljaKushtoreService } from './folja-kushtore.service';
import { FoljaLidhoreHabitoreService } from './folja-lidhore-habitore.service';
import { FoljaLidhoreService } from './folja-lidhore.service';
import { FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraService } from './folja-urdherore-trajta-te-shkurtra-te-bashkuara.service';
import { FoljaUrdheroreTrajtaTeShkurtraDhanoreService } from './folja-urdherore-trajta-te-shkurtra-dhanore.service';
import { FoljaUrdheroreTrajtaTeShkurtraKallezoreService } from './folja-urdherore-trajta-te-shkurtra-kallezore.service';
import { FoljaUrdheroreService } from './folja-urdherore.service';
import { FoljaFormaPashtjelluarService } from './folja-forma-pashtjelluar.service';
import { FoljaDeftoreForCreationDTO } from '@core/interfaces/dto/folja-deftore-for-creation-dto.interface';
import { FoljaHabitoreForCreationDTO } from '@core/interfaces/dto/folja-habitore-for-creation-dto.interface';
import { FoljaLidhoreForCreationDTO } from '@core/interfaces/dto/folja-lidhore-for-creation-dto.interface';
import { FoljaLidhoreHabitoreForCreationDTO } from '@core/interfaces/dto/folja-lidhore-habitore-for-creation-dto.interface';
import { FoljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO } from '@core/interfaces/dto/folja-urdherore-trajta-te-shkurtra-dhanore-for-creation-dto.interface';
import { FoljaFormaPashtjelluarForCreationDTO } from '@core/interfaces/dto/folja-forma-pashtjelluar-for-creation-dto.interface';
import { FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO } from '@core/interfaces/dto/folja-urdherore-trajta-te-shkurtra-te-bashkuara-for-creation-dto.interface';
import { FoljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO } from '@core/interfaces/dto/folja-urdherore-trajta-te-shkurtra-kallezore-for-creation-dto.interface';
import { FoljaUrdheroreForCreationDTO } from '@core/interfaces/dto/folja-urdherore-for-creation-dto.interface';
import { FoljaDeshiroreForCreationDTO } from '@core/interfaces/dto/folja-deshirore-for-creation-dto.interface';
import { FoljaKushtoreForCreationDTO } from '@core/interfaces/dto/folja-kushtore-for-creation-dto.interface';
import { FoljaBazaForUpdateDTO } from '@core/interfaces/dto/folja-baza-for-update-dto.interface';
import { FoljaBazaForCreationDTO } from '@core/interfaces/dto/folja-baza-for-creation-dto.interface';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FoljaEditorService {
  constructor(
    private fb: UntypedFormBuilder,
    private foljaDeftoreService: FoljaDeftoreService,
    private foljaDeshiroreService: FoljaDeshiroreService,
    private foljaHabitoreService: FoljaHabitoreService,
    private foljaLidhoreService: FoljaLidhoreService,
    private foljaLidhoreHabitoreService: FoljaLidhoreHabitoreService,
    private foljaKushtoreService: FoljaKushtoreService,
    private foljaUrdheroreService: FoljaUrdheroreService,
    private foljaUrdheroreTrajtaTeShkurtraDhanoreService: FoljaUrdheroreTrajtaTeShkurtraDhanoreService,
    private foljaUrdheroreTrajtaTeShkurtraKallezoreService: FoljaUrdheroreTrajtaTeShkurtraKallezoreService,
    private foljaUrdheroreTrajtaTeShkurtraTeBashkuaraService: FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraService,
    private foljaFormaPashtjelluarService: FoljaFormaPashtjelluarService
  ) { }

  getFoljaBazaForm(form: UntypedFormGroup) {
    if (form.get('foljaBaza')) {
      return form.get('foljaBaza') as UntypedFormGroup;
    }

    form.addControl(
      'foljaBaza',
      this.fb.group({
        id: null,
        bazaId: null,
        vetaId: null,
        diatezaId: null,
        zgjedhimiId: null,
        llojiTemesId: null,
        klasaId: {
          value: null,
          disabled: true,
        },
        nenklasaId: {
          value: null,
          disabled: true,
        },
        kalimtaresiaId: null,
        veproreParam: true,
        joveproreParam: true,
        veproreNjejesParam: false,
        veproreShumesParam: false,
        joveproreNjejesParam: false,
        joveproreShumesParam: false,
        f1: null,
        f1a: null,
        f1b: null,
        f2: null,
        f3: null,
        f3a: null,
        f3b: null,
        f4: null,
        f5: null,
        f6: null,
        f6a: null,
        f6b: null,
        f7: null,
        f8: null,
        veproreBazaId: null,
        veproreNyjaId: null,
        veproreFjala: null,
        veproreHomonim: null,
        foljaDeftore: this.fb.array([]),
        foljaDeftoreInitial: this.fb.array([]),
        foljaDeftoreFormula: this.fb.array([]),
        foljaDeshirore: this.fb.array([]),
        foljaDeshiroreInitial: this.fb.array([]),
        foljaDeshiroreFormula: this.fb.array([]),
        foljaHabitore: this.fb.array([]),
        foljaHabitoreInitial: this.fb.array([]),
        foljaHabitoreFormula: this.fb.array([]),
        foljaLidhore: this.fb.array([]),
        foljaLidhoreInitial: this.fb.array([]),
        foljaLidhoreFormula: this.fb.array([]),
        foljaLidhoreHabitore: this.fb.array([]),
        foljaLidhoreHabitoreInitial: this.fb.array([]),
        foljaLidhoreHabitoreFormula: this.fb.array([]),
        foljaKushtore: this.fb.array([]),
        foljaKushtoreInitial: this.fb.array([]),
        foljaKushtoreFormula: this.fb.array([]),
        foljaUrdherore: this.fb.array([]),
        foljaUrdheroreInitial: this.fb.array([]),
        foljaUrdheroreFormula: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraDhanore: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraDhanoreInitial: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraDhanoreFormula: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraKallezore: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraKallezoreInitial: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraKallezoreFormula: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraTeBashkuara: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraTeBashkuaraInitial: this.fb.array([]),
        foljaUrdheroreTrajtaTeShkurtraTeBashkuaraFormula: this.fb.array([]),
        foljaFormaPashtjelluar: this.fb.array([]),
        foljaFormaPashtjelluarInitial: this.fb.array([]),
        foljaFormaPashtjelluarFormula: this.fb.array([]),
      })
    );

    this.foljaDeftoreService.generateForms(form.get('foljaBaza.foljaDeftore') as UntypedFormArray);
    this.foljaDeftoreService.generateForms(form.get('foljaBaza.foljaDeftoreInitial') as UntypedFormArray);
    this.foljaDeshiroreService.generateForms(form.get('foljaBaza.foljaDeshirore') as UntypedFormArray);
    this.foljaDeshiroreService.generateForms(form.get('foljaBaza.foljaDeshiroreInitial') as UntypedFormArray);
    this.foljaHabitoreService.generateForms(form.get('foljaBaza.foljaHabitore') as UntypedFormArray);
    this.foljaHabitoreService.generateForms(form.get('foljaBaza.foljaHabitoreInitial') as UntypedFormArray);
    this.foljaLidhoreService.generateForms(form.get('foljaBaza.foljaLidhore') as UntypedFormArray);
    this.foljaLidhoreService.generateForms(form.get('foljaBaza.foljaLidhoreInitial') as UntypedFormArray);
    this.foljaLidhoreHabitoreService.generateForms(form.get('foljaBaza.foljaLidhoreHabitore') as UntypedFormArray);
    this.foljaLidhoreHabitoreService.generateForms(form.get('foljaBaza.foljaLidhoreHabitoreInitial') as UntypedFormArray);
    this.foljaKushtoreService.generateForms(form.get('foljaBaza.foljaKushtore') as UntypedFormArray);
    this.foljaKushtoreService.generateForms(form.get('foljaBaza.foljaKushtoreInitial') as UntypedFormArray);
    this.foljaUrdheroreService.generateForms(form.get('foljaBaza.foljaUrdherore') as UntypedFormArray);
    this.foljaUrdheroreService.generateForms(form.get('foljaBaza.foljaUrdheroreInitial') as UntypedFormArray);
    this.foljaUrdheroreTrajtaTeShkurtraDhanoreService.generateForms(form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraDhanore') as UntypedFormArray);
    this.foljaUrdheroreTrajtaTeShkurtraDhanoreService.generateForms(form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraDhanoreInitial') as UntypedFormArray);
    this.foljaUrdheroreTrajtaTeShkurtraKallezoreService.generateForms(form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraKallezore') as UntypedFormArray);
    this.foljaUrdheroreTrajtaTeShkurtraKallezoreService.generateForms(form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraKallezoreInitial') as UntypedFormArray);
    this.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraService.generateForms(form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraTeBashkuara') as UntypedFormArray);
    this.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraService.generateForms(form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraInitial') as UntypedFormArray);
    this.foljaFormaPashtjelluarService.generateForms(form.get('foljaBaza.foljaFormaPashtjelluar') as UntypedFormArray);
    this.foljaFormaPashtjelluarService.generateForms(form.get('foljaBaza.foljaFormaPashtjelluarInitial') as UntypedFormArray);

    return form.get('foljaBaza') as UntypedFormGroup;
  }

  generateFormula(baza: string, foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    this.foljaDeftoreService.generateFormula(baza, foljaBaza, form);
    this.foljaDeshiroreService.generateFormula(baza, foljaBaza, form);
    this.foljaHabitoreService.generateFormula(baza, foljaBaza, form);
    this.foljaLidhoreService.generateFormula(baza, foljaBaza, form);
    this.foljaLidhoreHabitoreService.generateFormula(baza, foljaBaza, form);
    this.foljaKushtoreService.generateFormula(baza, foljaBaza, form);
    this.foljaUrdheroreService.generateFormula(baza, foljaBaza, form);
    this.foljaUrdheroreTrajtaTeShkurtraDhanoreService.generateFormula(baza, foljaBaza, form);
    this.foljaUrdheroreTrajtaTeShkurtraKallezoreService.generateFormula(baza, foljaBaza, form);
    this.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraService.generateFormula(baza, foljaBaza, form);
    this.foljaFormaPashtjelluarService.generateFormula(baza, foljaBaza, form);
  }

  private _refreshPipes$: Subject<void> = new Subject<void>();

  onRefreshPipe() {
    return this._refreshPipes$.asObservable();
  }

  getFoljaBazaDTO(form: UntypedFormGroup) {
    const fb = this.getFoljaBazaForm(form).getRawValue();

    const foljaDeftoreForCreationDTO: FoljaDeftoreForCreationDTO[] = this.foljaDeftoreService.getCreationDTO(form);
    const foljaDeshiroreForCreationDTO: FoljaDeshiroreForCreationDTO[] = this.foljaDeshiroreService.getCreationDTO(form);
    const foljaHabitoreForCreationDTO: FoljaHabitoreForCreationDTO[] = this.foljaHabitoreService.getCreationDTO(form);
    const foljaLidhoreForCreationDTO: FoljaLidhoreForCreationDTO[] = this.foljaLidhoreService.getCreationDTO(form);
    const foljaLidhoreHabitoreForCreationDTO: FoljaLidhoreHabitoreForCreationDTO[] = this.foljaLidhoreHabitoreService.getCreationDTO(form);
    const foljaKushtoreForCreationDTO: FoljaKushtoreForCreationDTO[] = this.foljaKushtoreService.getCreationDTO(form);
    const foljaUrdheroreForCreationDTO: FoljaUrdheroreForCreationDTO[] = this.foljaUrdheroreService.getCreationDTO(form);
    const foljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO: FoljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO[] =
      this.foljaUrdheroreTrajtaTeShkurtraDhanoreService.getCreationDTO(form);
    const foljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO: FoljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO[] =
      this.foljaUrdheroreTrajtaTeShkurtraKallezoreService.getCreationDTO(form);
    const foljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO: FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO[] =
      this.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraService.getCreationDTO(form);
    const foljaFormaPashtjelluarForCreationDTO: FoljaFormaPashtjelluarForCreationDTO[] = this.foljaFormaPashtjelluarService.getCreationDTO(form);

    if (fb.id) {
      const foljaBazaForUpdateDTO: FoljaBazaForUpdateDTO = {
        id: fb.id,
        bazaId: fb.bazaId,
        vetaId: fb.vetaId,
        diatezaId: fb.diatezaId,
        kalimtaresiaId: fb.kalimtaresiaId,

        foljaDeftoreForCreationDTO: foljaDeftoreForCreationDTO,
        foljaDeshiroreForCreationDTO: foljaDeshiroreForCreationDTO,
        foljaHabitoreForCreationDTO: foljaHabitoreForCreationDTO,
        foljaLidhoreForCreationDTO: foljaLidhoreForCreationDTO,
        foljaLidhoreHabitoreForCreationDTO: foljaLidhoreHabitoreForCreationDTO,
        foljaKushtoreForCreationDTO: foljaKushtoreForCreationDTO,
        foljaUrdheroreForCreationDTO: foljaUrdheroreForCreationDTO,
        foljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO: foljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO,
        foljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO: foljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO,
        foljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO: foljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO,
        foljaFormaPashtjelluarForCreationDTO: foljaFormaPashtjelluarForCreationDTO,

        zgjedhimiId: fb.zgjedhimiId,
        llojiTemesId: fb.llojiTemesId,
        klasaId: fb.klasaId,
        nenklasaId: fb.nenklasaId,
        veproreParam: fb.veproreParam,
        joveproreParam: fb.joveproreParam,
        veproreNjejesParam: fb.veproreNjejesParam,
        veproreShumesParam: fb.veproreShumesParam,
        joveproreNjejesParam: fb.joveproreNjejesParam,
        joveproreShumesParam: fb.joveproreShumesParam,
        f1: fb.f1,
        f1a: fb.f1a,
        f1b: fb.f1b,
        f2: fb.f2,
        f3: fb.f3,
        f3a: fb.f3a,
        f3b: fb.f3b,
        f4: fb.f4,
        f5: fb.f5,
        f6: fb.f6,
        f6a: fb.f6a,
        f6b: fb.f6b,
        f7: fb.f7,
        f8: fb.f8,

        veproreBazaId: fb.veproreBazaId,
        veproreNyjaId: fb.veproreNyjaId,
        veproreFjala: fb.veproreFjala,
        veproreHomonim: fb.veproreHomonim
      };

      return foljaBazaForUpdateDTO;
    } else {
      const foljaBazaForCreationDTO: FoljaBazaForCreationDTO = {
        id: fb.id,
        bazaId: fb.bazaId,
        vetaId: fb.vetaId,
        diatezaId: fb.diatezaId,
        kalimtaresiaId: fb.kalimtaresiaId,

        foljaDeftoreForCreationDTO: foljaDeftoreForCreationDTO,
        foljaDeshiroreForCreationDTO: foljaDeshiroreForCreationDTO,
        foljaHabitoreForCreationDTO: foljaHabitoreForCreationDTO,
        foljaLidhoreForCreationDTO: foljaLidhoreForCreationDTO,
        foljaLidhoreHabitoreForCreationDTO: foljaLidhoreHabitoreForCreationDTO,
        foljaKushtoreForCreationDTO: foljaKushtoreForCreationDTO,
        foljaUrdheroreForCreationDTO: foljaUrdheroreForCreationDTO,
        foljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO: foljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO,
        foljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO: foljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO,
        foljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO: foljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO,
        foljaFormaPashtjelluarForCreationDTO: foljaFormaPashtjelluarForCreationDTO,

        zgjedhimiId: fb.zgjedhimiId,
        llojiTemesId: fb.llojiTemesId,
        klasaId: fb.klasaId,
        nenklasaId: fb.nenklasaId,
        veproreParam: fb.veproreParam,
        joveproreParam: fb.joveproreParam,
        veproreNjejesParam: fb.veproreNjejesParam,
        veproreShumesParam: fb.veproreShumesParam,
        joveproreNjejesParam: fb.joveproreNjejesParam,
        joveproreShumesParam: fb.joveproreShumesParam,
        f1: fb.f1,
        f1a: fb.f1a,
        f1b: fb.f1b,
        f2: fb.f2,
        f3: fb.f3,
        f3a: fb.f3a,
        f3b: fb.f3b,
        f4: fb.f4,
        f5: fb.f5,
        f6: fb.f6,
        f6a: fb.f6a,
        f6b: fb.f6b,
        f7: fb.f7,
        f8: fb.f8,

        veproreBazaId: fb.veproreBazaId,
        veproreNyjaId: fb.veproreNyjaId,
        veproreFjala: fb.veproreFjala,
        veproreHomonim: fb.veproreHomonim
      };
      return foljaBazaForCreationDTO;
    }
  }

  insertFoljaBazaIntoEditor(foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    this.resetFoljaBaza(form);

    this.getFoljaBazaForm(form).patchValue({
      id: foljaBaza.id,
      bazaId: foljaBaza.bazaId,
      fjala: foljaBaza.fjala,
      vetaId: foljaBaza.vetaId,
      diatezaId: foljaBaza.diatezaId,
      kalimtaresiaId: foljaBaza.kalimtaresiaId,
      zgjedhimiId: foljaBaza.zgjedhimiId,
      llojiTemesId: foljaBaza.llojiTemesId,
      klasaId: foljaBaza.klasaId,
      nenklasaId: foljaBaza.nenklasaId,
      veproreParam: foljaBaza.veproreParam,
      joveproreParam: foljaBaza.joveproreParam,
      veproreNjejesParam: foljaBaza.veproreNjejesParam,
      veproreShumesParam: foljaBaza.veproreShumesParam,
      joveproreNjejesParam: foljaBaza.joveproreNjejesParam,
      joveproreShumesParam: foljaBaza.joveproreShumesParam,
      f1: foljaBaza.f1,
      f1a: foljaBaza.f1a,
      f1b: foljaBaza.f1b,
      f2: foljaBaza.f2,
      f3: foljaBaza.f3,
      f3a: foljaBaza.f3a,
      f3b: foljaBaza.f3b,
      f4: foljaBaza.f4,
      f5: foljaBaza.f5,
      f6: foljaBaza.f6,
      f6a: foljaBaza.f6a,
      f6b: foljaBaza.f6b,
      f7: foljaBaza.f7,
      f8: foljaBaza.f8,
      veproreBazaId: foljaBaza.veproreBazaId,
      veproreNyjaId: foljaBaza.veproreNyjaId,
      veproreFjala: foljaBaza.veproreFjala,
      veproreHomonim: foljaBaza.veproreHomonim
    });

    this.insertFormsIntoEditor(foljaBaza, form);
  }

  insertFormsIntoEditor(foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    this.foljaDeftoreService.insertForms(foljaBaza, form);
    this.foljaHabitoreService.insertForms(foljaBaza, form);
    this.foljaLidhoreService.insertForms(foljaBaza, form);
    this.foljaLidhoreHabitoreService.insertForms(foljaBaza, form);
    this.foljaKushtoreService.insertForms(foljaBaza, form);
    this.foljaDeshiroreService.insertForms(foljaBaza, form);
    this.foljaUrdheroreService.insertForms(foljaBaza, form);
    this.foljaUrdheroreTrajtaTeShkurtraDhanoreService.insertForms(foljaBaza, form);
    this.foljaUrdheroreTrajtaTeShkurtraKallezoreService.insertForms(foljaBaza, form);
    this.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraService.insertForms(foljaBaza, form);
    this.foljaFormaPashtjelluarService.insertForms(foljaBaza, form);

    this._refreshPipes$.next();
  }

  getErrors(form: UntypedFormGroup) {
    const foljaBazaForm = this.getFoljaBazaForm(form);
    let errors: {
      menyraId: number;
      kohaId?: number;
      formaId?: number;
      vetaId?: number;
      numriId?: number;
      formaFjalesId?: number | null;
      trajtaTeShkurtraDhanoreId?: number;
      trajtaTeShkurtraKallezoreId?: number;
      trajtaTeShkurtraTeBashkuaraId?: number;
      formaPashtjelluarId?: number;
      pershkrimi: string;
    }[] = [];

    errors = errors.concat(this.foljaDeftoreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaHabitoreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaLidhoreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaLidhoreHabitoreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaKushtoreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaDeshiroreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaUrdheroreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaUrdheroreTrajtaTeShkurtraDhanoreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaUrdheroreTrajtaTeShkurtraKallezoreService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraService.getErrors(foljaBazaForm));
    errors = errors.concat(this.foljaFormaPashtjelluarService.getErrors(foljaBazaForm));

    return errors;
  }

  private resetFoljaBaza(form: UntypedFormGroup) {
    this.getFoljaBazaForm(form).reset({
      id: null,
      bazaId: null,
      vetaId: null,
      diatezaId: null,
      kalimtaresiaId: null,
      zgjedhimiId: null,
      llojiTemesId: null,
      klasaId: null,
      nenklasaId: null,
      veproreParam: true,
      joveproreParam: true,
      veproreNjejesParam: false,
      veproreShumesParam: false,
      joveproreNjejesParam: false,
      joveproreShumesParam: false,
      f1: null,
      f1a: null,
      f1b: null,
      f2: null,
      f3: null,
      f3a: null,
      f3b: null,
      f4: null,
      f5: null,
      f6: null,
      f6a: null,
      f6b: null,
      f7: null,
      f8: null,
      veproreBazaId: null,
      veproreNyjaId: null,
      veproreFjala: null,
      veproreHomonim: null
    });

    Object.keys(this.getFoljaBazaForm(form).controls)
      .filter((c) => c.startsWith('folja'))
      .flatMap((field) => {
        return form.get('foljaBaza')?.get(field) as UntypedFormArray;
      })
      .forEach((formArray) => {
        while (formArray.controls.length > 0) {
          formArray.removeAt(0);
        }
      });
  }
}
